<template>
  <div
    v-if="questionnaire.questions"
    class="grid grid-rows-2 grid-cols-[2fr_3fr] gap-2 p-3 flex-1 border rounded-md">
    <div class="overflow-y-auto bg-white">
      <div class="p-2 rounded-md bg-theme-50">
        <div v-for="(group, groupId) in groupItems" :key="groupId" class="">
          <div
            class="flex items-center justify-between p-4 mb-2 bg-white rounded-md cursor-pointer text-theme-600 hover:bg-theme-100">
            <p>{{ group.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="h-full px-2 space-y-3">
      <QuestionnairesGenericQuestionCard :questions="questionnaire.questions" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';
import QuestionnairesGenericQuestionCard from './QuestionnairesGenericQuestionCard.vue';
import { getGroupItemsForQstGenericGroups } from '@/services/api/groups';
import type { GroupItem } from '@/types/Groups';
import type { Questionnaire } from '@/types/Questionnaires';

const props = defineProps<{
  questionnaire: Questionnaire;
}>();

const groupItems = ref<GroupItem[]>();
onMounted(async () => {
  if (!props.questionnaire.bindingId) return;
  const res = await getGroupItemsForQstGenericGroups(props.questionnaire.bindingId);
  if (res) groupItems.value = res.data;
});
</script>
